// import {clearAllDataAsyncStorage} from '../../../Booking_App/src/utils';
import {
  GET_DATA_FROM_SERVER_API_CALL,
  GET_DATA_FROM_SERVER_API_CALL_SUCCESS,
  GET_DATA_FROM_SERVER_API_CALL_FAIL,
  LOG_OUT,
  CLEAR_DATA_BY_KEY,
  IS_ERROR_CLEAR,

} from './ActionType';

export const logOut = data => ({
  type: LOG_OUT,

});

export const ClearError = data => ({
  type: IS_ERROR_CLEAR,
});

// Action to start API call
export const httpRequest = params => ({
  type: GET_DATA_FROM_SERVER_API_CALL,
  payload: params,
});

// Action to start API call
export const clearByKey = params => ({
  type: CLEAR_DATA_BY_KEY,
  payload: params,
});

// Action for successful API response
export const httpRequestSuccess = data => ({
  type: GET_DATA_FROM_SERVER_API_CALL_SUCCESS,
  payload: {
    server_res: data?.server_res,
    existing_payload: data?.existing_payload,
  },
});

// Action for failed API response
export const httpRequestFail = data => ({
  type: GET_DATA_FROM_SERVER_API_CALL_FAIL,
  payload: {
    server_res: data?.server_res,
    existing_payload: data?.existing_payload,
  },
});

